import { SEARCH } from "../../../assets/js/constants";
import SearchResults from "../search-results/search-results";

const SELECTORS = {
  input: "SearchBox-input",
  searchResults: "SearchResults",
  datasets: {
    api: "searchApi",
    form: "searchForm",
    category: "searchCategory",
    throttle: "searchThrottle",
  },
};

/**
 * This class handles the search box functionality by
 * initializing the searchResults dropdown and handle all
 * query requests
 */
class SearchBox {
  /**
   *
   * @param {HTMLElement} element
   */
  constructor(element) {
    this.searchBox = element;
    this.throttleSearch = false;
    this.searchString = "";

    this._setBindings();
    this._initializeSearchBox();
  }

  /**
   * Query all necessary elements and setup a new Search Results instance
   */
  _initializeSearchBox() {
    this.searchApi = this.searchBox.dataset[SELECTORS.datasets.api];
    this.searchForm = this.searchBox.dataset[SELECTORS.datasets.form];
    this.searchCategory = this.searchBox.dataset[SELECTORS.datasets.category];
    const searchThrottle = this.searchBox.dataset[SELECTORS.datasets.throttle];
    if (searchThrottle) {
      this.throttleDuration = Number(searchThrottle);
    } else {
      this.throttleDuration = SEARCH.throttleDuration;
    }
    this.input = this.searchBox.querySelector(`.${SELECTORS.input}`);
    this.list = this.searchBox.querySelector(`.${SELECTORS.searchResults}`);

    this.searchResults = new SearchResults(this.list);

    this._updateActionUrl();
    this._addEventListener();
  }

  /**
   * Set bindings using methods in callbacks
   */
  _setBindings() {
    this._querySearch = this._querySearch.bind(this);
  }

  /**
   * Add the input eventListener to refresh the action url and
   * query the search throttled
   */
  _addEventListener() {
    this.input.addEventListener("input", () => {
      this.searchString = this._getSearchString();
      this._updateActionUrl();
      this._throttle(this._querySearch);
    });
  }

  /**
   * Update the forms action url with correct url params
   */
  _updateActionUrl() {
    const formUrl = `${this.searchForm}?search=${this.searchString}&category=${this.searchCategory}`;
    this.searchBox.action = formUrl;
    this.searchResults.updateShowMoreButton(this.searchString);
  }

  /**
   *  Call a callback after a given delay
   *
   * @param {Function} callback
   * @returns {undefined}
   */
  _throttle(callback) {
    if (this.throttleSearch) return;
    this.throttleSearch = true;
    setTimeout(() => {
      if (this.input.value.trim().length) {
        callback(this.input.value);
      } else {
        this.searchResults.handleResults();
      }
      this.throttleSearch = false;
    }, this.throttleDuration);
  }

  /**
   * Query the searchAPI
   */
  _querySearch() {
    const apiUrl = `${this.searchApi}?search=${this.searchString}&category=${this.searchCategory}`;
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) =>
        this.searchResults.handleResults(data /* defined by backend */)
      );
  }

  /**
   * Returns a uri encoded string
   *
   * @returns {string}
   */
  _getSearchString() {
    return encodeURI(this.input.value);
  }
}

export default SearchBox;
